import React from 'react';

import { trades } from '../data/site';

/**
 * Continuous trade ticker. The list is doubled so the -50% keyframe
 * loops seamlessly: at the halfway point the track is showing the copy,
 * pixel-identical to the start.
 */
export default function TradeTicker() {
    const lane = [...trades, ...trades];

    return (
        <div className="marquee" aria-hidden="true">
            <div className="marquee__track">
                {lane.map((trade, i) => (
                    <span className="marquee__item" key={`${trade}-${i}`}>
                        {trade}
                        <span className="marquee__sep" />
                    </span>
                ))}
            </div>
        </div>
    );
}
